"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var Card_1 = __importDefault(require("../../../../common/Card/Card"));
var HeaderBar_1 = __importDefault(require("../../../../theme/headerbar/HeaderBar"));
var react_i18next_1 = require("react-i18next");
var Report = function () {
    var push = (0, react_router_dom_1.useHistory)().push, t = (0, react_i18next_1.useTranslation)().t;
    return (react_1.default.createElement(HeaderBar_1.default, { title: 'report', hideSave: true },
        react_1.default.createElement("div", { style: { flexDirection: 'row', display: 'flex' } },
            react_1.default.createElement(Card_1.default, { text: t('general'), icon: 'setting', onClick: function () {
                    push('/admin/general');
                } }),
            react_1.default.createElement(Card_1.default, { text: t('guide'), icon: 'sensitation_report', onClick: function () {
                    push('/admin/general/Guide');
                } }),
            react_1.default.createElement(Card_1.default, { text: t('knowledge'), icon: 'knowledge_report', onClick: function () {
                    push('/admin/general/Knowledge');
                } }),
            react_1.default.createElement(Card_1.default, { text: t('participant'), icon: 'participant', onClick: function () {
                    push('/admin/general/participant');
                } }),
            react_1.default.createElement(Card_1.default, { text: t('area_mapping'), icon: 'area_mapping', onClick: function () {
                    push('/admin/general/Area%20Mapping');
                } }))));
};
exports.default = Report;
